import { inject, injectable } from "inversify";
import type { IF360Validator } from "./F360Validator";
import { DIMixins, DIValidators } from "@/core/@types/types";
import "reflect-metadata";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";

@injectable()
export default class ContabilLiberadoValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  @inject(DIValidators.CIELO)
  private cieloValidator!: IF360Validator;

  @inject(DIValidators.CADIS)
  private cadisValidator!: IF360Validator;

  private isCielo() {
    return this.cieloValidator.handleValidation();
  }

  private isCadis() {
    return this.cadisValidator.handleValidation();
  }

  private getUserProfile() {
    const userProfile = this.userProfileMixin.handleGetUserProfile();

    return userProfile;
  }

  private hasContabiLiberado() {
    const userProfile = this.getUserProfile();

    return userProfile?.ContabilLiberado || false;
  }

  handleValidation(): boolean {
    if (this.isCadis() || this.isCielo()) return false;

    return this.hasContabiLiberado();
  }
}
